import { defaultXrayEditorApi } from 'ContentEditorUI/lib/xray/defaultEditorXrayApi';
// @ts-expect-error not in TS yet
import { updatePostBodyFromXrayPanel } from '../actions/postContentModelActions';
export const xrayEditorApi = Object.assign({}, defaultXrayEditorApi, {
  updateBlogPostBody: updatePostBodyFromXrayPanel
});